import {
  ScrollSidebarTitleItem,
  ScrollSidebarTitleItemProps,
  LockIcon,
  CheckBolderIcon,
} from '@equifinance/shared';
import styled from 'styled-components';
import { SectionTitleIcon, SectionTitleIconProps } from '../Account/Icons/SectionTitleIcon';
import {
  IconCircle,
} from '../Account/components/Icons';
import { usePageConfigurationContext } from '../../contexts/pageConfiguration';
import CrossIcon from '../Account/Icons/CrossIcon';

type SectionSidebarItemProps = ScrollSidebarTitleItemProps & SectionTitleIconProps;

export const IconCircleSmall = styled(IconCircle)`${({ theme }) => `
  width:${theme.fontSize[2]};
  height:${theme.fontSize[2]};
  margin-left:2px;
`}`;

export function SectionSidebarItem(props: SectionSidebarItemProps) {
  const { errors, isLocked = false, isCompleted = true } = props;
  const { isReadOnly } = usePageConfigurationContext();

  return (
    <ScrollSidebarTitleItem
      icon={(
        <SectionTitleIcon
          errors={errors}
          isLocked={isLocked || isReadOnly}
          isCompleted={isCompleted}
          tickIcon={(
            <IconCircleSmall>
              <CheckBolderIcon />
            </IconCircleSmall>
          )}
          crossIcon={(
            <CrossIcon size={17} />
          )}
          lockIcon={<LockIcon small />}
        />
  )}
      {...props}
    />
  );
}
